import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const MVPDevelopment = () => {
  return <PageTemplate title="MVP Development" subtitle="Rapid Prototyping" breadcrumb="Engineering > MVP Development"><div className="content-section"><p>Minimum viable product development and rapid prototyping services.</p></div></PageTemplate>;
};
export default MVPDevelopment; 